import React from 'react'
import HomePage from '../parts/pages/HomePage'

export default function Home() {
  return <HomePage />
}
